export default __webpack_public_path__ + "static/media/iloilo_province_seal2.f26b60d2.png";